import { render, staticRenderFns } from "./IframeLayout.vue?vue&type=template&id=4eec1232&"
import script from "./IframeLayout.vue?vue&type=script&lang=js&"
export * from "./IframeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports